import { useDispatch, useSelector } from 'react-redux'
import PropTypes from 'prop-types'
import { setScopedFilter, selectFiltersForScope } from '../reducers'
import Switcher from '../../../components/switcher/Switcher'

const FILTER_VALUE_OPTIONS = {
  ACCOUNT: 'account',
  OWNED: 'owned',
  OTHER: 'other',
}

const SWITCHER_OPTIONS = [
  {
    label: 'Account timelines',
    description: 'Public account timelines and the timelines you own.',
    value: FILTER_VALUE_OPTIONS.ACCOUNT,
  },
  {
    label: 'Your timelines',
    description: 'Just the timelines you own.',
    value: FILTER_VALUE_OPTIONS.OWNED,
  },
  {
    label: 'Other timelines',
    description: 'Timelines you can access through groups or explicit permissions.',
    value: FILTER_VALUE_OPTIONS.OTHER,
  },
]

const VisibilityFilter = props => {
  const { uiScope, filterName } = props

  const dispatch = useDispatch()
  const filters = useSelector(state => selectFiltersForScope(state, uiScope))
  const value = filters[filterName]

  const handleChange = value => {
    dispatch(setScopedFilter({ uiScope, filterName, value }))
  }

  return <Switcher options={SWITCHER_OPTIONS} value={value} onChange={handleChange} />
}

VisibilityFilter.propTypes = {
  uiScope: PropTypes.string.isRequired,
  filterName: PropTypes.string.isRequired,
}

VisibilityFilter.defaultProps = {
  filterName: 'visibility',
}

export default VisibilityFilter
